
import Vue from "vue";
import AppExtraFieldsInfo from "@/components/ExtraFieldsInfo.vue";
import { ExtraFieldNamesConfig } from "@/models/dossier-configs/extra-field-names-config";
import { Purchase } from "@/models/base";
import { DossierConfigService } from "@/services";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => Purchase,
			required: true
		},
	},
	computed: {
		extraFieldsNameSettings():ExtraFieldNamesConfig {
			return DossierConfigService.getExtraFieldNamesConfigs().PurchaseNames;
		}
	},
	components: {
		AppExtraFieldsInfo
	}
});

